export function hardNavigate(url) {
  window.location.assign(url);
}
